import Input from '../../../../Core/Fields/Floating/Input';

const Tab2 = ({ pageState, itemCodeList,handleChange}) => {
  return (
    <div className="row mb-3" style={{ border: "1px solid #00000059", borderRadius: "5px" }}>
      <div className="col-12">
        <p className="boxLabel m-0">Warranty / AMC Details</p>
      </div>

      <div className="col-6 ">
        <div className="mb-3">
          <Input
            type="date"
            id="WarrantyExpiryDate"
            label="Warranty Expiry Date"
            style={{
              height: "38px",
             
            }}
            value={pageState.warrantyExpiryDate}
            onChange={(e) => handleChange('warrantyExpiryDate', e.target.value)}
          />
        </div>
      </div>

      <div className="col-6">
        <div className="mb-3">
          <Input
            type="date"
            id="AmcExpiryDate"
            style={{
              height: "38px",
              
            }}
            label="AMC Expiry Date"
            value={pageState.amcExpiryDate}
            onChange={(e) => handleChange('amcExpiryDate', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default Tab2;